import { render, staticRenderFns } from "./recorderror.vue?vue&type=template&id=11a5d7cf"
import script from "./recorderror.vue?vue&type=script&lang=js"
export * from "./recorderror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports